import styled from '@emotion/styled'
import { palette } from '@edge/spark/ui-mui'
import { Gavel } from '@mui/icons-material'
import { Typography } from '@mui/material'

/**
 * Renders a counter for proxy bids with the Gavel icon.
 * Used in any change of conditions of vehicle component to show the presence of proxy bids.
 */
export const ProxyBidsCounter = ({ count }: { count: number | undefined | null }): JSX.Element | null => {
    if (count && count > 0) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: '130px',
                    marginLeft: '10px',
                }}
            >
                <StyledGavelIcon />
                <Typography style={{ color: palette.text.primary }} variant="subtitle1">
                    {count}
                    {count === 1 ? ' Proxy Bid' : ' Proxy Bids'}
                </Typography>
            </div>
        )
    } else return null
}

const StyledGavelIcon = styled(Gavel)`
    margin: 0 10px 0 0;
    ${({ theme }) => /* css */ `
  color: ${palette.text.secondary};
  `}
`
